import React, { useState } from "react";

const Specialities = () => {
  const allSpecialities = [
    {
      title: "Proctology",
      desc: "Specialised & advanced treatment for Anorectal Diseases ...",
      img: "/assets/img/services/Proctology.jpg",
    },
    {
      title: "Laparoscopy",
      desc: "Keyhole surgery for abdominal and pelvic disorders ...",
      img: "/assets/img/services/Laparoscopy.webp",
    },
    {
      title: "Gynaecology",
      desc: "Treatment of diseases related to female reproductive organs ...",
      img: "/assets/img/services/Gynaecology.jpg",
    },
    {
      title: "Vascular",
      desc: "Focuses on arteries, veins and lymphatic conditions ...",
      img: "/assets/img/services/Vascular.jpeg",
    },
    {
      title: "Aesthetics",
      desc: "Reconstruction or improvement of physical appearance ...",
      img: "/assets/img/services/Aesthetics.jpg",
    },
    {
      title: "Orthopaedics",
      desc: "Focuses on injuries and diseases of musculoskeletal system ...",
      img: "/assets/img/services/Orthopaedics.jpg",
    },
    {
      title: "Fertility",
      desc: "Treatment of health issues related to infertility ...",
      img: "/assets/img/services/Fertility.webp",
    },
    {
      title: "Weight Loss",
      desc: "Advanced bariatric surgery & gastric balloon treatment ...",
      img: "/assets/img/services/Weight Loss.webp",
    },
    {
      title: "Dermatology",
      desc: "Treating Skin Conditions, Enhancing Natural Beauty ...",
      img: "/assets/img/services/Dermatology.avif",
    },
  ];

  const [showAll, setShowAll] = useState(false);
  const visibleSpecialities = showAll ? allSpecialities : allSpecialities.slice(0, 6);

  return (
    <div
      style={{
        padding: "100px 20px",
        background: "radial-gradient(circle at 50% 20%, #e7f2ff 0%, #ffffff 70%)",
        fontFamily: "'Poppins', sans-serif",
        textAlign: "center",
      }}
    >
      {/* Section Heading */}
      <h2
        style={{
          fontSize: "42px",
          fontWeight: "800",
          color: "#0b1c39",
          marginBottom: "60px",
        }}
      >
        Our <span style={{ color: "#ffcb24" }}>Specialities</span>
      </h2>

      {/* Cards Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "25px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {visibleSpecialities.map((item, index) => (
          <div
            key={index}
            style={{
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "20px",
              borderRadius: "20px",
              boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
          >
            {/* Image */}
            <div
              style={{
                flexShrink: 0,
                width: "80px",
                height: "80px",
                borderRadius: "12px",
                overflow: "hidden",
                marginRight: "18px",
                border: "2px solid #09bbaf",
              }}
            >
              <img
                src={item.img}
                alt={item.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
              />
            </div>

            {/* Text */}
            <div style={{ flexGrow: 1, textAlign: "left" }}>
              <h3
                style={{
                  fontSize: "18px",
                  fontWeight: "700",
                  color: "#0b1c39",
                  marginBottom: "8px",
                }}
              >
                {item.title}
              </h3>
              <p
                style={{
                  fontSize: "15px",
                  color: "#555",
                  lineHeight: 1.6,
                  margin: 0,
                }}
              >
                {item.desc}
              </p>
            </div>

            {/* Arrow */}
            <div
              style={{
                fontSize: "24px",
                color: "#ffcb24",
                marginLeft: "10px",
                flexShrink: 0,
                transition: "transform 0.3s ease",
              }}
            >
              ➜
            </div>
          </div>
        ))}
      </div>

      {/* Button */}
      <div style={{ marginTop: "50px" }}>
        <button
          onClick={() => setShowAll(!showAll)}
          style={{
            background: "#09bbaf",
            color: "#fff",
            padding: "16px 40px",
            border: "none",
            borderRadius: "12px",
            fontSize: "17px",
            fontWeight: "700",
            cursor: "pointer",
            boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
            transition: "all 0.3s ease",
          }}
        >
          {showAll ? "Show Less" : "View More Specialities ▼"}
        </button>
      </div>
    </div>
  );
};

export default Specialities;
